<template>
  <basic-container>
    <mc-exception404 />
  </basic-container>
</template>


<script>
import McException404 from "./../../../blocks/mc-exception404/index.js";

export default {
  components: {
    McException404
  }
};
</script>
